<template>
	<div>
		<div :class="isdiag?'allheaddiag':'allhead '">
			<div  v-if="Stringtitle">{{Stringtitle}}</div>
			<div :style="headtitle.length>1?'opacity:0.4':''" v-if="headtitle">{{headtitle[0]}}</div>
			<div v-if="headtitle" :style="headtitle.length>1?'margin-left:10px;margin-right: 10px;opacity:0.4':'display:none' ">></i></div>
			<div  v-if="headtitle">{{headtitle[1]}}</div>
			
		</div>
		<div class="headtou" v-if="!noheadtou"></div>
	</div>
</template>

<script>
	export default {
		props: {
		    headtitle: {
		        type: Array, //指定传入的类型
		        //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
		    },
			isdiag:{
				type: Boolean
			},
      noheadtou:{
        type: Boolean
      },
			Stringtitle:{
				 type: String,
			}
		},
	    components:{
	    },
	    data() {
	        return {
	        };
	    },
	    created(){
		
	    },
	    methods: {
		
	    },
	};
</script>

<style  scoped="scoped" lang="less">
	.allhead:extend(.Centerupdown){
		display: none;
			height: 50px;
	border-bottom: 1px solid #CFCFCF;
	font-size: 18px;
	color: #0080FF;
	padding-left: 23px;
	margin-bottom: 24px;
		}
		.headtou{
			height: 30px;
		}
		.allheaddiag{
		border-bottom: 1px solid #CFCFCF;
		font-size: 20px;
		color: #0080FF;
		padding-left: 23px;
		margin-bottom: 24px;
		padding-bottom: 24px;
			}
</style>
